module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/furniture_quantities/size-1-33b0020c06bf3db5ed4c4d25a7b68a30.svg";